import * as t from "io-ts";
import nullable from "./nullable";
import { cargoTypeT } from "./types";
import { weekdaysT } from "./weekday";
const phoneNoT = t.strict({
    countryCode: t.string,
    number: t.string,
});
export const baseDriverT = t.strict({
    number: t.string,
    firstName: t.string,
    lastName: t.string,
    email: nullable(t.string),
    phoneNo: phoneNoT,
    canAddRoutes: t.boolean,
    canEditCargos: t.boolean,
    canSeeClients: t.boolean,
    canAddInvoiceRef: t.boolean,
    canAddInvoiceLines: t.boolean,
    canDeleteOwnCargoStops: t.boolean,
    canAddUndispatchedCargos: t.boolean,
    autoArriveDepartOnStopCreate: t.boolean,
    defaultTrailerId: nullable(t.string),
    defaultLanguage: t.string,
    defaultCargoType: nullable(cargoTypeT),
});
export const updateDriverT = t.intersection([
    baseDriverT,
    t.strict({ pin: nullable(t.string) }),
]);
export const addDriverT = t.intersection([
    baseDriverT,
    t.strict({ pin: t.string }),
]);
export const driverScheduleTypeT = t.union([
    t.literal("INTERVAL"),
    t.literal("RECURRENT"),
]);
export const createDriverTypes = ({ dateTime, }) => {
    const baseDriverScheduleT = t.strict({
        type: driverScheduleTypeT,
        startDate: nullable(dateTime),
        endDate: nullable(dateTime),
        weekdays: nullable(weekdaysT),
        absenceNote: nullable(t.string),
        recurrentTimeInterval: nullable(t.string),
    });
    const driverScheduleT = t.intersection([
        baseDriverScheduleT,
        t.strict({ id: t.string }),
    ]);
    const driverSchedulesT = t.array(driverScheduleT);
    const driverT = t.intersection([
        baseDriverT,
        t.strict({
            id: t.string,
            teams: t.array(t.string),
            active: t.boolean,
            hasActivities: t.boolean,
        }),
        t.strict({ schedules: t.array(driverScheduleT) }),
    ]);
    const driversT = t.array(driverT);
    return {
        driverT,
        driversT,
        driverScheduleT,
        driverSchedulesT,
        baseDriverScheduleT,
    };
};
export const driversCanBeDeletedStatusT = t.array(t.string);
//# sourceMappingURL=driver.js.map